export default {
	referenceGrid: {
		bindsInfo: "Linking info",
		appsToWhichBaseLinked: "Apps, to which the base is linked",
		toUnlinkAppsGoToDeleteMenu: "To unlink specific apps from the base go to deletion menu",
		currentBaseNotLinkedToApp: "current base is not linked to any app",
		basesLinkedToApp: "Bases that are linked to the app",
		packetsWithSection: "Packets that include the app",
		noPacketsWithSection: "there are no packets that include the app",
		toDeletePackets: "To delete the packets go to related CRON server",
		toUnlinkBasesGoToDeleteMenu: "To unlink specific bases from the app go to deletion menu",
		noLinkedBasesToCurrentApp: "there are no bases linked to the app",
		enterDataForNewApp: "Enter data for the new app",
		copied: "Being copied",
		copyAttention: "Attention: the copying happens in the same server",
		name: "Name",
		alias: "Alias",
		path: "Path",
		cancel: "Cancel",
		insert: "Add",
		copy: "Copy",
		info: "Info",
		edit: "Edit",
		delete: "Delete",
		view: "View",
		compact: "Optimal",
		full: "Full",
		enterNameForNewApp: "Enter the new app name",
		enterPathForNewApp: "Enter the new app path",
		desirableEnterAliasField: "It is preferable to fill the 'Alias' field",
		continueWithoutAlias: "Continue without 'Alias'",
		attention: "Attention",
		continue: "Continue",
		return: "Return"
	}
}